import mergeobj from '../extraUtil/mergeTwoObj';

export default function dataSourceGenerator(rawData, timeSelectorValue, theme) {
  let chart,
    dataSource = {},
    data = [],
    delivered = 0,
    inTimedelivered = 0;
  for (let i = 0; i < rawData.length; i++) {
    let status = rawData[i]['status'],
      shipmentDelay = rawData[i]['shipmentDelay'];
    if (status === 'Delivered') {
      if (shipmentDelay <= 1) {
        inTimedelivered++;
      }
      delivered++;
    }
  }
  data.push({
    "label": "Late Delivery",
    "value": delivered - inTimedelivered,
    "showlabel": "0"
  });
  data.push({
    "label": "On Time Delivery",
    "value": inTimedelivered,
    "showlabel": "0"
  });
  chart = {
    "valuefontsize": "10",
    "palettecolors": "#3E517A, #70ae6e",
    "plotfillalpha": "100",
    "resizeanimduration": "0",
    "use3dlighting": "0",
    "enableSmartLabels": "0",
    "showvalues": "0",
    "showlabels": "0",
    "pieradius": "60",
    "doughnutradius": "52",
    "enableslicing": "0",
    "updateAnimDuration": "0",
    "startingangle": "90",
    "chartBottomMargin":"0",
    "chartLeftMargin":"0",
    "chartRightMargin":"0",
    "chartTopMargin":"0",
    "defaultcenterlabel": Math.ceil((inTimedelivered * 100) / delivered) + "%",
    "centerlabelfontsize":"30",
    "centerlabelcolor":"#247BA0",
    "centerlabelfontbold": "1"
  };
  chart = mergeobj(chart, theme);
  dataSource = {
    chart: chart,
    data: data
  }
  return dataSource
}


// WEBPACK FOOTER //
// ./src/util/dataSourceGenerators/deliveryDelayGenerator.js